import React from 'react'
import routes from '../config/settings/routes'
import BrandLayout from '../components/Layouts/BrandLayout'
import ProtectByFeatures from '../components/Security/ProtectByFeatures'
import FooterContainer from '../containers/Footer/Footer.container'
import RegionalAmountsTradedSectionContainer from '../containers/RegionalAmountsTradedSection/RegionalAmountsTradedSection.container'
import RegionalItemsAndProductsSectionContainer from '../containers/RegionalItemsAndProductsSection/RegionalItemsAndProductsSection.container'
import RegionalProvidersSectionContainer from '../containers/RegionalProvidersSection/RegionalProvidersSection.container'
import RegionalPurchasingMechanismsSectionContainer from '../containers/RegionalPurchasingMechanismsSection/RegionalPurchasingMechanismsSection.container'
import RegionalSectionContainer from '../containers/RegionalSection/RegionalSection.container'
import SearchBuyerPanelContainer from '../containers/SearchBuyerPanel/SearchBuyerPanel.container'
import TopNavbarContainer from '../containers/TopNavbar/TopNavbar.container'
import NotFoundPage from './NotFound'

/**
 * The RegionalInfo's page.
 */
const RegionalInfo = () => (
  <ProtectByFeatures
    fallback={() => <NotFoundPage />}
    rule={features => features['cl.chilecompra.datos-abiertos/regional-info-page']}
  >
    <BrandLayout footer={<FooterContainer />}>
      <TopNavbarContainer menuActive={routes.regionalInfo.replace(/\/:regionSlug/, '')} />
      <SearchBuyerPanelContainer />
      <RegionalSectionContainer>
        <RegionalAmountsTradedSectionContainer />
        <RegionalPurchasingMechanismsSectionContainer />
        <RegionalProvidersSectionContainer />
        <RegionalItemsAndProductsSectionContainer />
      </RegionalSectionContainer>
    </BrandLayout>
  </ProtectByFeatures>
)

export default RegionalInfo
